import type {
  PreferenceCardListItemDto,
  PreferenceCardListTrackedAssetsDto,
  PreferenceCardListUntrackedAssetsDto,
} from '@peritasai/types';

export class PreferenceCardListItemEntity {
  public readonly id: string;
  public readonly hospitalPreferenceCardId: string;
  public readonly surgeonName: string;
  public readonly caseTypeDisplayName: string;
  public readonly hospitalCaseTypeId: string;
  public readonly version: number;
  public readonly isActive: boolean;
  public readonly trackedAssets: PreferenceCardListTrackedAssetsDto;
  public readonly untrackedAssets: PreferenceCardListUntrackedAssetsDto;

  constructor(dto: PreferenceCardListItemDto) {
    this.id = dto.preferenceCardId;
    this.hospitalPreferenceCardId = dto.hospitalPreferenceCardId;
    this.surgeonName = dto.surgeon.fullName;
    this.caseTypeDisplayName = dto.caseType.displayName;
    this.hospitalCaseTypeId = dto.caseType.hospitalCaseTypeId;
    this.version = dto.version;
    this.isActive = dto.isActive;
    this.trackedAssets = dto.trackedAssets;
    this.untrackedAssets = dto.untrackedAssets;
  }

  /** Returns tracked asset type labels with item counts, e.g. ["Case Carts (4)", "Trays (8)"] */
  public getTrackedAssetTypes(): string[] {
    const types: string[] = [];
    if (this.trackedAssets.caseCarts.length > 0) types.push(`Case Carts (${this.trackedAssets.caseCarts.length})`);
    if (this.trackedAssets.trays.length > 0) types.push(`Trays (${this.trackedAssets.trays.length})`);
    if (this.trackedAssets.equipment.length > 0) types.push(`Equipment (${this.trackedAssets.equipment.length})`);
    if (this.trackedAssets.implants.length > 0) types.push(`Implants (${this.trackedAssets.implants.length})`);
    if (this.trackedAssets.stretchers.length > 0) types.push(`Stretchers (${this.trackedAssets.stretchers.length})`);
    return types;
  }

  /** Returns untracked asset type labels with item counts, e.g. ["Supplies (3)", "Single-packed (2)"] */
  public getUntrackedAssetTypes(): string[] {
    const types: string[] = [];
    if (this.untrackedAssets.supplies.length > 0) types.push(`Supplies (${this.untrackedAssets.supplies.length})`);
    if ((this.untrackedAssets.singlePackedInstruments ?? []).length > 0) types.push(`Single-packed (${this.untrackedAssets.singlePackedInstruments!.length})`);
    if ((this.untrackedAssets.instruments ?? []).length > 0) types.push(`Instruments (${this.untrackedAssets.instruments!.length})`);
    return types;
  }
}
